import segmentPlugin from '@analytics/segment'
import { AnalyticsAction, AnalyticsPageAction, AnalyticsTrackAction, AnalyticsActionType } from '@wppopen/core'
import Analytics from 'analytics'

import { excludeFalsy, isString } from 'utils/common'

export const analytics = Analytics({
  app: 'wpp-tccc-communities-of-practitioners',
  plugins: [
    segmentPlugin({
      writeKey: process.env.REACT_APP_ANALYTICS_SEGMENT_TOKEN,
    }),
  ].filter(excludeFalsy),
})

export const reset = () => {
  analytics.reset()
}

const getAnalyticsTenantAzId = () => analytics?.getState()?.user?.traits?.tenantAzId

const trackPage = ({ payload }: AnalyticsPageAction) => {
  const analyticsTenantAzId = getAnalyticsTenantAzId()
  if (analyticsTenantAzId) {
    analytics.page(
      {
        title: payload,
      },
      {
        agency: analyticsTenantAzId,
      },
    )
  }
}

const trackAction = ({ payload }: AnalyticsTrackAction) => {
  const analyticsTenantAzId = getAnalyticsTenantAzId()
  if (analyticsTenantAzId) {
    if (isString(payload)) {
      analytics.track(payload, {
        agency: analyticsTenantAzId,
      })
    } else {
      const { action, params } = payload

      analytics.track(action, {
        agency: analyticsTenantAzId,
        ...Object.fromEntries(params.map(({ key, value }) => [key, value])),
      })
    }
  }
}

export const trackAnalytics = (action: AnalyticsAction) => {
  switch (action.type) {
    case AnalyticsActionType.page:
      trackPage(action)
      break

    case AnalyticsActionType.action:
      trackAction(action)
      break

    default:
      break
  }
}

export const ANALYTICS_EVENTS = {
  OVERVIEW_PAGE_LOAD: 'pg_pv_brief_overview_page',
  OVERVIEW_WORKFRONT_BUTTON_CLICKED: 'pg_brief_status_overview_workfront_button',
  OVERVIEW_UHUB_BUTTON_CLICKED: 'pg_brief_status_overview_UHUB_button',
  SORT_AND_FILTER: 'pg_brief_status_overview_sort_and_filter',
  FILTERS_APPLY: 'pg_brief_status_overview_apply_filters',
  OVERVIEW_ITEM_EXPANDED: (projectName: string) => `pg_brief_status_overview_item_expanded_${projectName}`,
  DETAILED_ITEM_UHUB_BUTTON_CLICKED: (projectName: string) => `pg_brief_status_overview_UHUB_button_${projectName}`,
  DETAILED_ITEM_WORKFRONT_BUTTON_CLICKED: (projectName: string) =>
    `pg_brief_status_overview_workfront_button_${projectName}`,
  DETAILED_ITEM_ATTACHMENTS_BUTTON_CLICKED: (projectName: string, attachmentName: string) =>
    `pg_brief_status_overview_document_download_${projectName}_${attachmentName}`,
  DETAILED_ITEM_STATUS_ACTION_CLICKED: (projectName: string) => `pg_brief_status_overview_action_${projectName}`,
}
